import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  inject,
  signal,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'plugins-startup-spinner',
  templateUrl: './startup-spinner.component.html',
  styleUrl: './startup-spinner.component.scss',
  imports: [CommonModule, FontAwesomeModule],
})
export class StartupSpinnerComponent
  implements AfterViewInit, OnInit, OnDestroy
{
  private readonly router = inject(Router);
  displayText = !!window.location.href.match(/(localhost|test|uat)/);
  readonly loading = signal(true);
  spinnerIcon = faCircleNotch;
  readonly text = signal('');
  timers: number[] = [];

  ngOnInit() {
    this.timers.push(
      window.setTimeout(() => {
        this.text.set(
          'This is taking longer than expected. Please be patient.',
        );
      }, 10000),
      window.setTimeout(() => {
        this.text.set('Something failed. Please try again later.');
      }, 60000),
    );
  }

  ngAfterViewInit(): void {
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        this.loading.set(false);
      }
    });
  }

  ngOnDestroy() {
    this.timers.forEach((timer) => clearTimeout(timer));
  }
}
